import { useDispatch, useSelector } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import { useContext, useEffect, useState } from "react";
import { SelectButton } from "primereact/selectbutton";
import { addDays, subDays, format, set, addMonths } from "date-fns";
import EventCalendar from "../../../../components/components/event-calendar/EventCalendar";
import { Sidebar } from "primereact/sidebar";
import ListAppointment from "./AdminListAppointment";
import { Button } from "primereact/button";
import AppointmentEditorDialog from "./AdminAppointmentEditorDialog";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";
import { ConfirmDialog } from "primereact/confirmdialog";
import { animate } from "framer-motion";
import { is } from "date-fns/locale";
import useIsMobile from "../../../../hooks/useIsMobile";
import AdminAppointmentMobilePage from "./AdminAppointmentMobilePage";
import AdminAppointmentWeeklyPage from "./AdminAppointmentWeeklyPage";

const AdminAppointmentMain = (props) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <AdminAppointmentMobilePage />;
  } else {
    return <AdminAppointmentWeeklyPage />;
  }
};

export default AdminAppointmentMain;
